export const TECHDOCS_EXTERNAL_ANNOTATION = 'backstage.io/techdocs-entity';
